import * as React from 'react';
import { Globals } from '../../utils';
import { DefaultLink } from '../link/link.component';
const ArmstrongConfigContext = React.createContext({
    routing: {
        LinkComponent: DefaultLink,
        location: undefined,
        navigate: (to, action) => { var _a, _b, _c, _d; return action === 'replace' ? (_b = (_a = Globals.Window) === null || _a === void 0 ? void 0 : _a.history) === null || _b === void 0 ? void 0 : _b.replaceState({}, '', to) : (_d = (_c = Globals.Window) === null || _c === void 0 ? void 0 : _c.history) === null || _d === void 0 ? void 0 : _d.pushState({}, '', to); },
    },
});
/**
 * Configuration for Armstrong
 *
 * Currently only used for routing integration - see Link in storybook for more information
 */
export const ArmstrongConfigProvider = ({ routing, children }) => {
    // ensure LinkComponent is memoised so that state changes that the config depends on (i.e. in location) don't cause all Links to remount - otherwise, each
    // new render would pass this a new Link meaning all references to it would be re-instantiated and remount
    const LinkComponent = React.useMemo(() => routing.LinkComponent, []);
    return React.createElement(ArmstrongConfigContext.Provider, { value: { routing: Object.assign(Object.assign({}, routing), { LinkComponent }) } }, children);
};
/** Access Armstrong's configuration - for internal Armstrong use */
export const useArmstrongConfig = () => React.useContext(ArmstrongConfigContext);
